
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getUploadDocumentTemplateDtoFormGroup() {
return new FormGroup({
    documentTemplateId: new FormControl<number | undefined>(undefined, [Validators.required]),
    file: new FormControl<string | undefined>('', [Validators.required]),
})
;
}
      